
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.034","height":"14.317"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.033 7.324a8.418 8.418 0 00-.124-1.455H7.158v2.757h3.866a3.313 3.313 0 01-1.431 2.175v1.789H11.9a6.991 6.991 0 002.133-5.266z","fill":"#5c8df5"}}),_c('path',{attrs:{"d":"M7.161 14.317a6.852 6.852 0 004.745-1.728L9.599 10.8a4.341 4.341 0 01-6.455-2.27H.761v1.844a7.159 7.159 0 006.4 3.943z","fill":"#5c8df5"}}),_c('path',{attrs:{"d":"M3.139 8.53a4.288 4.288 0 010-2.741V3.946H.761a7.164 7.164 0 000 6.428z","fill":"#5c8df5"}}),_c('path',{attrs:{"d":"M7.161 2.833a3.89 3.89 0 012.746 1.073l2.044-2.044A6.88 6.88 0 007.161 0a7.157 7.157 0 00-6.4 3.945l2.378 1.844a4.282 4.282 0 014.022-2.956z","fill":"#5c8df5"}})])
          )
        }
      }
    